<template>
    <b-modal :id="modalId" size="lg" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
        <div id="header">
            <span class="title">{{ $t('objectives.editObjective') }}</span>
            <i class="close-button fas fa-times" @click="closeModal" />
        </div>
        <b-row>
            <b-col class="descriptions-column" cols="5">
                <Descriptions />
            </b-col>
            <b-col class="form-column">
                <Form ref="form" @submit="onSubmit" @cancel="closeModal" :isSubmitting="isSubmitting" />
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import { putObjective } from '../api'
import { Form, Descriptions } from './components'
import { success, danger } from '@/lib/notification'

export default {
    components: {
        Form,
        Descriptions,
    },
    data() {
        return {
            modalId: 'edit-objective-modal',
            isSubmitting: false,
        }
    },
    mounted() {
        this.$bvModal.show(this.modalId)
    },
    methods: {
        async onSubmit(objectiveId, payload) {
            try {
                this.setIsSubmitting(true)
                await this.updateObjective(objectiveId, payload)
            } catch (e) {
                console.error(e)
                this.showErrorNotification()
            } finally {
                this.setIsSubmitting(false)
            }
        },
        setIsSubmitting(value) {
            this.isSubmitting = value
        },
        updateObjective(objectiveId, payload) {
            putObjective(objectiveId, payload)
                .then(() => {
                    this.closeModal()
                    this.$emit('onUpdatedObjective')
                })
                .catch((error) => {
                    console.error(error)
                })
        },
        showSuccessNotification() {
            success(
                this.$t('notification.createdSuccessfully', {
                    item: this.$t('objectives.objective'),
                })
            )
        },
        showErrorNotification() {
            danger()
        },
        closeModal() {
            this.$router.back()
        },
    },
}
</script>

<style lang="scss" scoped>
#header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #009ada;
    }

    .close-button {
        color: #3b3f4e;
        cursor: pointer;
        font-size: 18px;
    }
}

::v-deep .modal-lg {
    max-width: 900px;
}

.descriptions-column {
    padding: 1rem;
}

.form-column {
    border-top: 0.5px solid #bec0c0;
    padding: 1rem;
}
</style>
